import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuAsideDirective } from './directives/menu-aside.directive';
import { MenuAsideOffcanvasDirective } from './directives/menu-aside-offcanvas.directive';
import { MenuHorizontalOffcanvasDirective } from './directives/menu-horizontal-offcanvas.directive';
import { MenuHorizontalDirective } from './directives/menu-horizontal.directive';
import { ClipboardDirective } from './directives/clipboard.directive';
import { ScrollTopDirective } from './directives/scroll-top.directive';
import { HeaderDirective } from './directives/header.directive';
import { MenuAsideToggleDirective } from './directives/menu-aside-toggle.directive';
import { QuickSidebarOffcanvasDirective } from './directives/quick-sidebar-offcanvas.directive';
import { FirstLetterPipe } from './pipes/first-letter.pipe';
import { TimeElapsedPipe } from './pipes/time-elapsed.pipe';
import { QuickSearchDirective } from './directives/quick-search.directive';
import { JoinPipe } from './pipes/join.pipe';
import { GetObjectPipe } from './pipes/get-object.pipe';
import { ConsoleLogPipe } from './pipes/console-log.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { ReplaceLineBreaks } from './pipes/replace-line-breaks.pipe';
import { PortletDirective } from './directives/portlet.directive';
import { DateTimeMaskDirective } from './directives/AppDateTimeMask.directive';
import { RatioNormalizerDirective } from './directives/AppRatioNormalizer.directive';
import { DigitOnlyDirective } from './directives/AppDigitOnly.directive';
import { DisableButtonDirective } from './directives/AppDisableButton.directive';
import { DisableControlDirective } from './directives/AppDisableControl.directive';
import { FourDigitDecimalNumberDirective } from './directives/FourDigitDecimalNumber.directive';
import { EqualValidator } from './directives/equal-validator.directive';
import { NotTurkishCharacterDirective } from './directives/NotTurkishCharacter.directive';
import { prefixCharacterDirective } from './directives/prefixCharacter.directive';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		// directives
		MenuAsideDirective,
		MenuAsideOffcanvasDirective,
		MenuHorizontalOffcanvasDirective,
		MenuHorizontalDirective,
		ScrollTopDirective,
		HeaderDirective,
		MenuAsideToggleDirective,
		QuickSidebarOffcanvasDirective,
		QuickSearchDirective,
		ClipboardDirective,
		PortletDirective,
		DateTimeMaskDirective,
		DigitOnlyDirective,
		NotTurkishCharacterDirective,
		RatioNormalizerDirective,
		DisableButtonDirective,
		DisableControlDirective,
		FourDigitDecimalNumberDirective,
		EqualValidator,
		// pipes
		FirstLetterPipe,
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		ConsoleLogPipe,
		SafePipe,
		ReplaceLineBreaks,
		prefixCharacterDirective
	],
	exports: [
		// directives
		MenuAsideDirective,
		MenuAsideOffcanvasDirective,
		MenuHorizontalOffcanvasDirective,
		MenuHorizontalDirective,
		ScrollTopDirective,
		HeaderDirective,
		MenuAsideToggleDirective,
		QuickSidebarOffcanvasDirective,
		QuickSearchDirective,
		ClipboardDirective,
		PortletDirective,
		DateTimeMaskDirective,
		DigitOnlyDirective,
		NotTurkishCharacterDirective,
		RatioNormalizerDirective,
		DisableButtonDirective,
		DisableControlDirective,
		FourDigitDecimalNumberDirective,
		EqualValidator,
		// pipes
		FirstLetterPipe,
		TimeElapsedPipe,
		JoinPipe,
		GetObjectPipe,
		ConsoleLogPipe,
		SafePipe,
		ReplaceLineBreaks,
		prefixCharacterDirective
	]
})
export class CoreModule { }
